import {AppMenu} from "mixins/menu"
import React from "react"
import NavigationItem from "../components/NavigationItem"
import NavigationModal from "../components/NavigationModal"
import {GlobalState} from "../state"
import {connect} from "react-redux"
import {AuctionsState} from "../redux/reducers/AuctionReducer"

type AppNavigationModalProps = {
  auctionsState: AuctionsState
}

type AppNavigationModalState = {
  modalOpen: boolean
}

class AppNavigationModal extends React.Component<AppNavigationModalProps, AppNavigationModalState> {
  constructor(props: AppNavigationModalProps) {
    super(props)

    this.state = {
      modalOpen: false
    }
  };

  openModal = () => {
    this.setState({modalOpen: true})
  }

  hideModal = () => {
    this.setState({modalOpen: false})
  }

  render() {
    return (
      <NavigationModal auctions={this.props.auctionsState} modalOpen={this.state.modalOpen} hideModal={this.hideModal} openModal={this.openModal}>
        {AppMenu().map(item => {
          return (
            <NavigationItem {...item} key={item.title} hideModal={this.hideModal}/>
          )
        })
        }
      </NavigationModal>
    )
  }
}

export default connect((state: GlobalState) => ({
  auctionsState: state.auctions
}))(AppNavigationModal)
